(function(){
  if (window.__mjRate1) return;
  window.__mjRate1 = true;

  var STAR = '<svg width="12" height="12" viewBox="0 0 24 24" aria-hidden="true">'
           + '<path d="M12 2.6l2.9 5.9 6.5.95-4.7 4.6 1.1 6.45L12 17.45 6.2 20.5l1.1-6.45-4.7-4.6 6.5-.95z"/>'
           + '</svg>';

  function small(){
    try { return window.matchMedia('(max-width: 767px)').matches; } catch (e) { return false; }
  }

  /* MJade 2026-09-18 — 후기 앱을 스탬프드에서 Judge.me 로 갈아탔다.
     예전 read() 는 .stamped-badge 만 봤는데 스탬프드를 지운 뒤로 그게 없어서
     늘 null 이 됐고, 그래서 .theme-product-reviews 에 mj-empty 가 붙어
     «가격 옆 별점» 이 통째로 사라져 있었다 [실측 2026-09-18].
     이제 세 군데를 차례로 본다. 하나라도 값이 있으면 그린다. */
  function read(wrap){
    /* ① Judge.me 가 페이지에 직접 심어 두는 값 — 가장 정확하다 */
    try {
      var d = window.jdgm && window.jdgm.data && window.jdgm.data.reviewWidget;
      if (d){
        for (var k in d){
          var o = d[k];
          if (!o) continue;
          var c1 = parseInt(o.number_of_reviews || 0, 10);
          var a1 = parseFloat(o.average_rating || 0);
          if (c1 > 0) return { cnt: c1, avg: a1 };
        }
      }
    } catch (e) {}

    /* ② 테마가 쇼피파이 후기 메타필드로 그려 둔 값 (Judge.me 가 채운다) */
    var cap = wrap.querySelector('.cc-rating-custom-caption');
    var num = wrap.querySelector('.cc-rating-text');
    if (cap || num){
      var cm2 = (cap && cap.textContent || '').match(/([0-9][0-9,]*)/);
      var am2 = (num && num.textContent || '').match(/([0-9]+(?:\.[0-9]+)?)/);
      var c2 = cm2 ? (parseInt(cm2[1].replace(/,/g, ''), 10) || 0) : 0;
      var a2 = am2 ? (parseFloat(am2[1]) || 0) : 0;
      if (c2 > 0) return { cnt: c2, avg: a2 };
    }

    /* ③ 옛 스탬프드 배지 — 남아 있으면 쓴다 */
    var b = wrap.querySelector('.stamped-badge');
    if (!b) return null;
    var lab = b.getAttribute('aria-label') || '';
    var cm = lab.match(/([0-9][0-9,]*)\s*review/i) || (wrap.textContent || '').match(/([0-9][0-9,]*)\s*review/i);
    var cnt = cm ? (parseInt(cm[1].replace(/,/g, ''), 10) || 0) : 0;
    var avg = parseFloat(b.getAttribute('data-rating') || '0');
    if (!cnt && avg > 0) cnt = 1;
    return { cnt: cnt, avg: avg };
  }

  /* MJade 2026-09-17 — 후기 구간(«CUSTOMER STORIES / Carried by you.» + 위젯) 통째로.
     구간 이름을 손으로 적지 않는다 — 위젯에서 거슬러 올라가 찾는다.
     0건일 때 「0.0 · 빈 별 다섯 · Be the first to review」 가 보이면 «나쁜 평가» 로 읽힌다. */
  /* MJade 2026-09-17 — 별점을 누르면 후기 구간으로 내려간다 (대표님 지시).
     ★ 일본 정본에는 「상세에 링크를 달지 않는다」고 적혀 있다. 미국만 다르게 간다. */
  /* ★ 2026-09-18 — 내려갈 자리도 Judge.me 위젯으로 바꾼다.
     #stamped-main-widget 은 이제 없어서 눌러도 아무 일이 없었다. */
  function 후기칸(){
    return document.querySelector('#judgeme_product_reviews')
        || document.querySelector('#stamped-main-widget');
  }

  function gotoReviews(){
    var wg = 후기칸();
    var sec = wg && wg.closest ? wg.closest('[id^="shopify-section"]') : null;
    if (!sec || getComputedStyle(sec).display === 'none') return;
    var head = document.querySelector('.pageheader');
    var pad = 0;
    if (head){
      var hs = getComputedStyle(head);
      if (hs.position === 'sticky' || hs.position === 'fixed') pad = head.getBoundingClientRect().height || 0;
    }
    var y = sec.getBoundingClientRect().top + window.pageYOffset - pad - 8;
    var soft = true;
    try { soft = !window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
    var se = document.scrollingElement || document.documentElement;
    /* ★ 이 화면에서는 브라우저의 부드러운 이동이 «안 먹는다» [실측:
       behavior:'smooth' 는 0, 'auto' 는 2806]. body 가 overflow:auto scroll 이어서다.
       그래서 부드러움을 직접 만든다 — 380ms ease-out. */
    if (!soft){ se.scrollTop = y; return; }
    /* ★ requestAnimationFrame 은 화면이 앞에 없으면 «한 프레임도» 안 돈다 [실측: 제자리].
       시계로 돌리고, 그래도 못 끝나면 420ms 뒤에 그냥 도착시킨다. 어떤 경우에도 도착은 한다. */
    var from = se.scrollTop, gap = y - from, t0 = Date.now(), done = false;
    function snap(){ if (done) return; done = true; se.scrollTop = y; }
    function step(){
      if (done) return;
      var p = Math.min(1, (Date.now() - t0) / 380);
      se.scrollTop = from + gap * (1 - Math.pow(1 - p, 3));
      if (p < 1) setTimeout(step, 16); else snap();
    }
    setTimeout(step, 16);
    setTimeout(snap, 420);
  }

  /* MJade 2026-09-17 — 구간 사이 여백 (대표님 지시).
     실측: 상품본문→추천상품 112px(너무 많다) · 추천→후기 24px(딱) · 후기→Our Story 24px(너무 좁다).
     추천→후기 는 손대지 않는다. */
  function sectionRhythm(){
    var small = false;
    try { small = window.matchMedia('(max-width: 767px)').matches; } catch (e) {}
    if (!small) return;
    var set = function(suffix, px){
      var el = document.querySelector('[id^="shopify-section-template--"][id$="__' + suffix + '"]');
      if (el) el.style.setProperty('margin-top', px + 'px', 'important');
    };
    /* 기준 한 칸 = 24px (대표님이 «딱» 이라 하신 추천상품→후기 간격).
       같은 묶음 안은 한 칸, 묶음이 바뀌면 두 칸(48px). */
    set('related-products', 48);   /* 112 → 48 */
    /* ★ 24 로 주면 «여백 겹침» 때문에 그대로 24 다 (맞닿은 여백은 큰 쪽 하나만 남는다).
       48 로 줘야 48 이 된다 [실측으로 확인]. */
    set('mjade_brand_story', 48);
    /* ★ 사진 격자는 상품마다 «있을 수도, 없을 수도» 있다.
       없을 때는 틀만 남아 높이 0 인데, 여백(위 48 + 아래 72)은 살아서 120px 짜리 빈 칸이 됐다
       [대표님 지적]. 그래서 사진이 한 장도 없으면 구간을 통째로 감춘다. */
    var lb = document.querySelector('[id^="shopify-section-template--"][id$="__mjade_lookbook"]');
    if (lb){
      if (!lb.querySelector('img')){
        lb.style.setProperty('display', 'none', 'important');
      } else {
        lb.style.removeProperty('display');
        /* ★ 2026-09-18 — 48 로 주면 «상세 → 격자» 만 혼자 110px 로 벌어진다.
           상세 구간이 제 아래 padding 50px 을 이미 갖고 있고, 격자 속 .mjade-lookbook
           도 padding-top 12px 을 갖고 있어서 50+48+12 가 됐다 [실측].
           여기서 준 인라인 !important 가 CSS 보다 세서 CSS 로는 못 줄였다.
           대표님 지시대로 «적정선» 인 8px 로 낮춘다 — 다른 구간(48px)과 비슷해진다. */
        set('mjade_lookbook', 8);                                     /* 48 → 8 */
        /* MJade 2026-09-17 — 아래 여백은 이제 구간 자신의 padding-bottom(96px)이 맡는다.
           바깥여백 72px 은 푸터와 만나는 자리에서 눌려 화면에 21px 밖에 안 나왔다 [실측].
           두 곳에서 주면 값이 겹치므로 여기서는 지운다. */
        lb.style.removeProperty('margin-bottom');
      }
    }
  }

  function reviewSection(has){
    var wg = 후기칸();
    var sec = wg && wg.closest ? wg.closest('[id^="shopify-section"]') : null;
    if (!sec) return;
    if (has) sec.style.removeProperty('display');
    else sec.style.setProperty('display', 'none', 'important');
  }

  function apply(){
    var pdp = document.body && document.body.classList.contains('template-product');
    /* ★ 여기서도 부른다. <head> 에서 한 번만 부르면 그때는 구간이 아직 안 그려져 있어
       아무것도 못 찾는다 [실측: 여백이 그대로였다]. apply() 는 여러 번 돈다. */
    if (pdp) sectionRhythm();
    var pc = document.querySelector('.product-info .price-container');
    var ws = document.querySelectorAll('.theme-product-reviews');

    for (var i = 0; i < ws.length; i++){
      var w = ws[i], v = read(w);

      /* ★ 2026-09-18 대표님 지시 — 「상품목록 쪽에서는 후기 아예 안 나오게, 카운팅」.
         상세(PDP)가 아니면 값이 있든 없든 감춘다.
         ※ 이 줄이 없으면 안 된다: read() 를 Judge.me 로 고치면서 목록 카드도 값을
           읽게 됐고, 그러면 아래 remove('mj-empty') 가 돌아 «전에는 안 보이던 별점이
           목록에 나타나는» 역효과가 난다. 고친 김에 생긴 구멍이라 여기서 막는다. */
      if (!pdp){ w.classList.add('mj-empty'); continue; }

      /* 후기 0건 — 아무것도 안 그린다. 아래 «후기 구간» 도 통째로 감춘다. */
      if (!v || v.cnt <= 0){
        w.classList.add('mj-empty');
        if (pdp && pc && small()) pc.style.setProperty('margin-bottom', '22px', 'important');
        if (pdp) reviewSection(false);
        continue;
      }
      w.classList.remove('mj-empty');
      if (pdp) reviewSection(true);
      if (!pdp) continue;                      /* 목록 카드는 안 건드린다 */

      /* 앱이 그린 노란 배지는 «요소에 직접» 감춘다 (시트 규칙으로는 안 눌린다) */
      var old = w.querySelector('.stamped-product-reviews-badge');
      if (old) old.style.setProperty('display', 'none', 'important');

      var txt = v.avg > 0 ? v.avg.toFixed(1) : '';
      var html = STAR
               + '<span class="mj-rate__num">' + txt + '</span>'
               + '<span class="mj-rate__cnt">(' + v.cnt + ')</span>';

      var mine = document.querySelector('.product-info .mj-rate') || w.querySelector('.mj-rate');
      if (!mine){
        mine = document.createElement('span');
        mine.className = 'mj-rate';
        mine.setAttribute('aria-label', 'Rated ' + txt + ' out of 5, ' + v.cnt + ' reviews');
      }
      if (mine.innerHTML !== html) mine.innerHTML = html;
      if (!mine.__mjGo){
        mine.__mjGo = true;
        mine.style.cursor = 'pointer';
        mine.setAttribute('role', 'button');
        mine.setAttribute('tabindex', '0');
        mine.addEventListener('click', function(e){ e.preventDefault(); gotoReviews(); });
        mine.addEventListener('keydown', function(e){
          if (e.key === 'Enter' || e.key === ' '){ e.preventDefault(); gotoReviews(); }
        });
      }

      /* ★ 2026-09-18 — PC 에서 별점이 «두 번» 나왔다 [대표님 지적].
         테마가 가격줄 오른쪽에 제 것(.cc-rating «5.0 / 5.0  32 reviews»)을 그리고,
         우리가 가격 아래에 또 하나(«★ 5.0 (32)»)를 그려서다.
         예전에는 read() 가 늘 null 이라 우리 것이 안 보여 겹치는 줄 몰랐다.
         → 테마 것을 감추고, 우리 것을 «그 자리»(가격줄 오른쪽)로 올린다.
           대표님 지시대로 PC 에서는 조금 키워 위계를 준다. */
      var 테마별 = w.querySelector('.cc-rating');
      if (테마별) 테마별.style.setProperty('display', 'none', 'important');

      if (pc){
        /* ★ 가격과 «같은 줄» 오른쪽 끝으로 옮긴다 (PC·모바일 모두) */
        if (mine.parentNode !== pc) pc.appendChild(mine);
        mine.style.setProperty('margin-left', 'auto', 'important');
        /* ★ margin-left:auto 만으로는 오른쪽 끝까지 안 갔다 [실측 2026-09-18 —
           가격칸 799~1289 인데 별점이 899 에 머물렀다]. 뒤에 형제가 하나 더 있어서
           space-between 이 별점을 가운데에 세운 것이다. 차례를 맨 뒤로 보내 끝에 붙인다. */
        mine.style.setProperty('order', '99', 'important');
        mine.style.setProperty('margin-right', '0', 'important');
        pc.style.setProperty('display', 'flex', 'important');
        /* ★ 이 칸은 원래 세로 배치(column)다. 가로로 돌리지 않으면
           align-items:center 가 «가로 가운데», space-between 이 «세로로 벌리기» 가 되어
           가격이 한가운데로 가고 별점이 그 아래로 내려간다 [실측]. */
        pc.style.setProperty('flex-direction', 'row', 'important');
        pc.style.setProperty('flex-wrap', 'nowrap', 'important');
        /* MJade 2026-09-17 — baseline 이 아니라 center 다.
           우리 표기의 첫 자식이 «별 그림» 이라 글자 기준선이 없어, baseline 으로 두면
           브라우저가 그림의 아래 모서리를 기준선으로 삼아 별점이 가격 밑으로 처졌다. */
        pc.style.setProperty('align-items', 'center', 'important');
        pc.style.setProperty('justify-content', 'space-between', 'important');
        pc.style.setProperty('margin-bottom', '22px', 'important');
        w.style.setProperty('display', 'none', 'important');   /* 빈 줄을 없앤다 */
        /* PC 는 한 치수 키운다 — 값과 나란히 서려면 이 정도는 돼야 읽힌다 */
        mine.style.setProperty('font-size', small() ? '' : '14px', 'important');
        var ㄱ = mine.querySelector('.mj-rate__num');
        var ㄴ = mine.querySelector('.mj-rate__cnt');
        if (ㄱ) ㄱ.style.setProperty('font-size', small() ? '' : '14px', 'important');
        if (ㄴ) ㄴ.style.setProperty('font-size', small() ? '' : '13px', 'important');
        var sv = mine.querySelector('svg');
        if (sv && !small()){ sv.setAttribute('width', '14'); sv.setAttribute('height', '14'); }
      } else {
        /* PC 는 지금 모습 그대로 — 가격 아래 제 줄에 둔다 */
        if (mine.parentNode !== w) w.appendChild(mine);
        mine.style.removeProperty('margin-left');
        w.style.removeProperty('display');
      }
    }
  }

  apply();
  sectionRhythm();
  window.addEventListener('resize', sectionRhythm);
  if (window.MutationObserver){
    new MutationObserver(function(){
      clearTimeout(window.__mjRateT);
      window.__mjRateT = setTimeout(apply, 80);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('DOMContentLoaded', apply);
  window.addEventListener('load', apply);
  window.addEventListener('resize', apply);
  setTimeout(apply, 1500);
  setTimeout(apply, 4000);
})();
